import FileName from '../../ComControl/FileName'
import { BrowserFileUtils, FileReader, FileWriter } from '@/platform'

/** 单段 UTF-8 字符串最大字节数，防止错位时 readString 按巨大 length 卡死主线程 */
const MAX_STR_BYTES = 32 * 1024 * 1024

function readUtf8StringLimited(reader: FileReader, maxBytes: number): string {
    const len = reader.readInt()
    if (len < 0 || len > maxBytes) {
        throw new RangeError(
            `CGItem: invalid string byte length ${len} (max ${maxBytes}). ` +
                `Usually means CG stream is misaligned (e.g. missing writeInt(4) prefix or wrong BGM/CG order).`
        )
    }
    if (len === 0) return ''
    const raw = reader.readSome(len)
    return BrowserFileUtils.bytesToString(raw)
}

class CGItem {
    public Name: string = '' //CG的名称
    public CGpath: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) //CG的完整路径
    public Message: string = '' //CG的内容介绍
    /**
     * @description: 转换二进制流
     * @param {type}
     * @return:
     */
    ToString() {
        return this.Name
    }

    constructor(param?: { name: string; path: FileName; msg: string } | FileReader) {
        if (param && 'name' in param) {
            const { name, path, msg } = param
            this.Name = name
            this.CGpath = path
            this.Message = msg
        } else if (param instanceof FileReader) {
            this.readBin(param as FileReader)
        } 
    }

    readBin(reader: FileReader): void {
        this.Name = readUtf8StringLimited(reader, MAX_STR_BYTES)
        this.CGpath = new FileName(reader)
        this.Message = readUtf8StringLimited(reader, MAX_STR_BYTES)
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        this.CGpath.writeBin(writer)
        writer.writeString(this.Message)
    }

    readVersionedOui(reader: FileReader): void {
        this.Name = reader.readString()
        this.CGpath.readVersionedOui(reader.readObj(reader.readInt()))
        this.Message = reader.readString()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeString(this.Name)
        this.CGpath.writeVersionedOui(writer)
        writer.writeString(this.Message)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default CGItem
